import { TranslatePipe } from "@ngx-translate/core";

import { KeyValue, LowerCasePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { ServiceTileAvailableComponent } from "../../../../components/dashboard/service-tile-available/service-tile-available";
import { ServiceTile } from "../../../../components/dashboard/service-tile/service-tile";
import { WiredServiceTile } from "../../../../components/dashboard/wired-service-tile/wired-service-tile";
import { WirelessServiceTile } from "../../../../components/dashboard/wireless-service-tile/wireless-service-tile";
import { subscriptionDescriptionKey, subscriptionTileNameKey } from "../../../../helpers/subscription-i18n";

@Component({
  selector: "dashboard-tile",
  templateUrl: "dashboard-tile.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LowerCasePipe,
    ServiceTileAvailableComponent,
    ServiceTile,
    TranslatePipe,
    WiredServiceTile,
    WirelessServiceTile,
  ],
})
export class DashboardTileComponent {
  protected subscription = input.required<KeyValue<any, any>>();
  protected customerActivities = input.required<any[]>();

  protected key = computed(() => this.subscription().key);
  private value = computed(() => this.subscription().value);

  protected available = computed(() => this.value().available && this.value().available === true);
  protected isLoading = computed(() => this.value().loading === undefined || this.value().loading === true);
  protected serviceMessages = computed(() => this.value().messages);
  protected serviceMessage = computed(() => this.serviceMessages() && this.serviceMessages[0]);
  protected serviceTitleKey = computed(() => subscriptionTileNameKey(this.key()));
  protected serviceBodyKey = computed(() => subscriptionDescriptionKey(this.key()));
  protected serviceUrl = computed(() => this.value().url);
  protected subscriptionCount = computed(() => this.value().subscriptions);
  protected firewallCount = computed(() => this.value().firewallsEnabled);
  protected forceColor = computed(() => this.value().forceColor ?? false);
  protected actionButtonText = computed(() => this.value().actionButtonText);
}
